import React from 'react';

import TeamsList from 'components/TeamsList';

import './DesktopSidebar.styles.css';

const DesktopSidebar = ({ }) => {
    return (
        <div className="desktop-sidebar">
            <div className="app-bar" />

            <div className="desktop-sidebar-main nice-scroll">
                <TeamsList type="column" showDirectTeams={true} showLinkedTeams={true} withSwitch={true} />
            </div>
        </div>
    );
}

export default DesktopSidebar;
